import { Component, OnInit } from '@angular/core';
import { ContactFormComponent } from '../../static/contact-form/contact-form.component';
import { CBaseComponent } from '../base/c-base.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';
import { SHeaderComponent } from '../../shared/s-header/s-header.component';

@Component({
    selector: 'app-c-contact-form',
    imports: [
        ContactFormComponent,
        SHeaderComponent
    ],
    templateUrl: './c-contact-form.component.html',
    styleUrl: './c-contact-form.component.scss'
})
export class CContactFormComponent extends CBaseComponent implements OnInit { 
  override ngOnInit() {
    this.singleLabels = [ElementsType.ComponentHeader];
    super.ngOnInit();
  }

}
